module.exports = __webpack_public_path__ + "img/238.f9ab4027.jpg";